import { render, staticRenderFns } from "./SuggestionDetails.vue?vue&type=template&id=d2b1f6e2&scoped=true"
import script from "./SuggestionDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./SuggestionDetails.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SuggestionDetails.vue?vue&type=style&index=0&id=d2b1f6e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b1f6e2",
  null
  
)

export default component.exports